// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__IZcw2","primary":"Button_primary__27pg4","large2small":"Button_large2small__luLOn"};